module.exports = __webpack_public_path__ + "media/images/ac_templates/201/red-6d5bb90e8cb448df9808f78c4357dd72.jpg";